import { CommonModule } from "@angular/common";
import { Component, Input, ViewChild, output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ModalComponent } from "../../shared/components/modal/modal.component";
import { InvoiceStatusEnum } from "../../shared/enums/invoice-status.enum";
import { AttendeeType } from "../../shared/models/attendee-type.model";
import { Attendee } from "../../shared/models/attendee.model";
import { AttendanceForm } from "../attendance-form/attendance-form.form";


@Component({
  selector: 'attendance-add-modal',
  templateUrl: './attendance-add-modal.component.html',
  standalone: true,
  imports: [ModalComponent, CommonModule,FormsModule],
  providers: [AttendanceForm]
})
export class AttendanceAddModalComponent {
  @Input({required:true}) public attendeeTypes: AttendeeType[] = [];

  @Input({required:true}) public attendee: Attendee = new Attendee();

  @Input({ required: true }) public registryLabel!: string;

  @Input({ required: true }) public isPaidEvent!: boolean;

  public exitModal = output<void>();

  public confirmAttendee = output<number | undefined>();

  @ViewChild('modal') public modal: ModalComponent | undefined;

  public selectedAttendeeType: AttendeeType | undefined;

  public noAttendeeSelected: boolean = false;


  get attendeeTypesExists(): boolean {
    return this.attendeeTypes.length > 0;
  };

  get attendeeTypeNotSelected(): boolean {
    return !(!this.selectedAttendeeType || this.attendeeTypesExists);
  };

  get hasPaid(): boolean | undefined {
    if (this.attendee?.registrationInvoiceId == null) {
      return undefined;
    }
    return this.attendee?.registrationInvoiceStatusId == InvoiceStatusEnum.Paid;
  }

  onConfirmClick(): void {
    if (this.attendeeTypes.length > 0) {
      //check if the type is imputed
      if (this.selectedAttendeeType === undefined) {
        return
      }
      this.confirmAttendee.emit(this.selectedAttendeeType.attendeeTypeId);
      this.exitModal.emit();
    } else {
      this.confirmAttendee.emit(undefined);
      this.exitModal.emit();
    }
  };
}
